import {
  GetComisionMembresiaEmpleadosBaja,
  DeleteComisionMembresiaPagoAnticipado
} from "../../../reducers/comisionMembresia";
import * as actions from "../../../actions/comisionMembresia";
import { Preview } from "../../../../types/IAction";

export interface PagoAnticipadoDispatcher {
  getEmpleadosDadosDeBaja: (
    periodo: string
  ) => Promise<Preview<GetComisionMembresiaEmpleadosBaja>>;
  deletePagoAnticipado: (
    periodo: string,
    idEmpleado: number,
    tipoEmpleado: string
  ) => Promise<Preview<DeleteComisionMembresiaPagoAnticipado>>;
}

export const pagoAnticipadoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => PagoAnticipadoDispatcher = dispatch => ({
  getEmpleadosDadosDeBaja: (periodo: string) => {
    return dispatch(actions.getEmpleadosDadosDeBaja(periodo));
  },
  deletePagoAnticipado: (
    periodo: string,
    idEmpleado: number,
    tipoEmpleado: string
  ) => {
    return dispatch(
      actions.deletePagoAnticipado(periodo, idEmpleado, tipoEmpleado)
    );
  }
});
